import * as yup from 'yup';
import {
  validationSchemaName,
  validationSchemaPhone,
  validationSchemaQuestion,
} from '../../formValidations';

export const validationSchema = yup.object({
  name: validationSchemaName,
  phoneNumber: validationSchemaPhone,
  question: validationSchemaQuestion,
});

export const QUESTION_PROMPT =
  "Please enter your question below and we'll let you know when an Advocate is available.";

export const CONTACT_PROMPT = 'Please enter your name and a mobile number we can reach you at:';

export const SUBMITTED = 'submitted';
